import styled from 'styled-components';
import { dsColors } from '@Backlot-Cars/archie';

export const PlacePickerContainer = styled.div.withConfig({
	shouldForwardProp: () => true,
})`
	width: 100%;

	gmpx-place-picker {
		width: 100%;
	}

	gmpx-place-picker::part(input) {
		border: 1px solid ${dsColors.colorFormBorder.default};
		border-radius: 0px;
		padding: 10px;
		font-size: var(--font-content-default, 16px);
		font-family: inherit;
		color: ${dsColors.colorText.textPrimary};
		background-color: ${dsColors.colorFormSurface.default};
		width: 100%;
		box-sizing: border-box;
		transition: border-color 0.15s ease;
		appearance: none;
		margin: 0;
		height: var(--inputHeight, 48px);
		min-height: var(--inputHeightSmallest, 48px);
		line-height: 1.5;
	}

	gmpx-place-picker::part(input):focus {
		outline: none;
		border-color: ${dsColors.colorBrand['500']};
	}

	gmpx-place-picker::part(input)::placeholder {
		color: ${dsColors.colorText.textDisabled};
	}
`;
